(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8125],{

/***/ 55467:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal-information-request-california",
      function () {
        return __webpack_require__(58439);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getInitialProps": function() { return /* binding */ getInitialProps; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37672);
/* harmony import */ var _src_landingPage_datasets_forms_ccpa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93568);
/* harmony import */ var _src_landingPage_datasets_meta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85666);
/* harmony import */ var _src_landingPage_views_Forms_templates_DataFormTemplate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75562);
/* harmony import */ var _src_platform_components_WorkInProgress_WorkInProgress__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58434);






var CcpaPage = function() {
    var notice = "Our Personal Information form is currently experiencing a temporary disruption due to unusually high and potentially malicious traffic.";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_src_platform_components_WorkInProgress_WorkInProgress__WEBPACK_IMPORTED_MODULE_5__/* .WorkInProgress */ .E, {
        enabled: false,
        notice: notice,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_layouts_LayoutComponents_NextHead__WEBPACK_IMPORTED_MODULE_1__/* .NextHead */ .B, {
                currentPath: "/personal-information-request-california",
                title: _src_landingPage_datasets_meta__WEBPACK_IMPORTED_MODULE_3__/* .meta.ccpa.title */ .$.ccpa.title,
                description: _src_landingPage_datasets_meta__WEBPACK_IMPORTED_MODULE_3__/* .meta.ccpa.description */ .$.ccpa.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_landingPage_views_Forms_templates_DataFormTemplate__WEBPACK_IMPORTED_MODULE_4__/* .DataFormTemplate */ .a, {
                type: "CCPA",
                data: _src_landingPage_datasets_forms_ccpa__WEBPACK_IMPORTED_MODULE_2__/* .ccpa */ .v
            })
        ]
    });
};
var getInitialProps = function() {
    return {
        props: {
            wrapper: "MarketingWrapper"
        }
    };
};
/* harmony default export */ __webpack_exports__["default"] = (CcpaPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,5675,8540,7299,9774,2888,179], function() { return __webpack_exec__(55467); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);